export { enableZoomOnHover };

let overlay: HTMLElement;

// create a container and set the full-size image as its background
function createOverlay(image: HTMLImageElement): HTMLElement {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    const parentElement = image.parentElement;
    if (parentElement) {
      parentElement.insertBefore(overlay, image);
    }
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container: HTMLElement, image: HTMLImageElement): void {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image: HTMLImageElement): void {
  const parentElement = image.parentElement;
  if (parentElement) {
    const grandParentElement = parentElement.parentElement;
    if (grandParentElement) {
      const loadingSpinner = grandParentElement.querySelector('.loading__spinner');
      if (loadingSpinner) {
        loadingSpinner.classList.toggle('hidden');
      }
    }
  }
}

function moveWithHover(image: HTMLImageElement, event: MouseEvent, zoomRatio: number): void {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = (event.target as HTMLElement).getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  if (overlay) {
    overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
    overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
  }
}

function magnify(image: HTMLImageElement, zoomRatio: number): void {
  const overlay = createOverlay(image);
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event: MouseEvent) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
}

function enableZoomOnHover(zoomRatio: number): void {
  const images = document.querySelectorAll('.image-magnify-hover') as NodeListOf<HTMLImageElement>;
  images.forEach((image) => {
    image.onclick = (event: MouseEvent) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
}

enableZoomOnHover(2);
